var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CapexAccountEditor", {
        attrs: { viewModel: _vm.capexAccountEditor },
        on: { "form-submit": _vm.handleCapexAccountEditorFormSubmit },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "strategy" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.showCapexCreator()
                    },
                  },
                },
                [_vm._v("Create capex")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _vm.rm
            ? _c("div", { staticClass: "mt-3" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.accounts, function (c) {
                        return _c("tr", { key: c.Id }, [
                          _c("td", [
                            _c("strong", [_vm._v(_vm._s(c.Name))]),
                            _c("br"),
                            _vm._v(_vm._s(c.Description)),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.Classification))]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showCapexEditor(c)
                                        },
                                      },
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "dropdown-divider",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteCapexAccountCommand(
                                            c
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Capex")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Capex")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }, [
          _vm._v("P&L depreciation"),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }